import styled from 'styled-components'

export const ReportsMonthSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ReportCardsContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`
